/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown>, date: NonNullable<unknown>, time: NonNullable<unknown> }} Vehicle_Details_Archived_SentenceInputs */

const fr_vehicle_details_archived_sentence = /** @type {(inputs: Vehicle_Details_Archived_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce véhicule ${i?.reason} le ${i?.date} à ${i?.time}.`)
};

const en_vehicle_details_archived_sentence = /** @type {(inputs: Vehicle_Details_Archived_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This vehicle ${i?.reason} on ${i?.date} at ${i?.time}.`)
};

/**
* | output |
* | --- |
* | "This vehicle {reason} on {date} at {time}." |
*
* @param {Vehicle_Details_Archived_SentenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archived_sentence = /** @type {((inputs: Vehicle_Details_Archived_SentenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archived_SentenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archived_sentence(inputs)
	return en_vehicle_details_archived_sentence(inputs)
});